module.exports = __webpack_public_path__ + "static/media/rightArrowCricket.0e255419.svg";